// Ots Tool Url
export const getSegmentOtsInfoUrl = "/api/v3/mavin/ots/road";
export const getLocationOtsInfoUrl = "/api/v3/mavin/ots";

// Ots  new methodology Tool Url
export const getSegmentOtsAndReachInfoUrl = "/api/v3/mavin/ots/road/new";
